import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../components/Layout';
import AboutUs from '../views/AboutUs';

const AboutUsPage = props => {
  const {
    pageContext: { locale },
    location: { pathname },
  } = props;

  return (
    <Layout locale={locale} localeDir={pathname}>
      <AboutUs locale={locale} />
    </Layout>
  );
};

AboutUsPage.propTypes = {
  pageContext: PropTypes.shape({
    locale: PropTypes.string,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

export default AboutUsPage;
